import i18n from 'i18next'
import moment from 'moment'

export const defaultLocale = 'ja'
export const locales = ['ja']

export const configureTranslation = translation => {
  const resources = {}
  locales.map(locale => {
    resources[locale] = translation
  })

  // momentのロケールも設定
  moment.locale(defaultLocale)
  i18n.on('languageChanged', lng => {
    moment.locale(lng)
  })

  i18n.init({ fallbackLng: defaultLocale, resources })
  return i18n
}
